export const REVIEW_TYPE = {
  SELF: {
    Id: 'self',
    Name: 'Self',
  },
  PEER: {
    Id: 'peer',
    Name: 'Peer',
  },
  MANAGER: {
    Id: 'manager',
    Name: 'Manager',
  },
  CONS: {
    Id: 'cons',
    Name: 'Consolidation',
  },
};
export const ALERT_VARIANT = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};

export const PLACEMENT = {
  BOTTOM_CENTER: 'bottom-center',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  TOP_CENTER: 'top-center',
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
};

export const RESPONSE_STATUS = {
  IDLE: 'idle',
  PENDING: 'pending',
  SUCCESS: 'success',
  ERROR: 'error',
};

export const EResponse_code = {
  ERROR: -25,
  SUCCESS: 0,
};

export const ACTIVE_TAB = {GENERAL: 'General'};

export const QUESTION_TYPE = {
  ESSAY: 'essay',
  SCORE_4: 'score4',
  SCORE_5: 'score5',
  SCORE_10: 'score10',
  SCORE_20: 'score20',
};

export const EQuestionByID = {
  LINIER_QUESTION: 0,
  ESSAY_QUESTION: 1,
  REQUIRED_QUESTION: 2,
};

export const QuestionClassname = {
  question: 'reviewTask-question',
  questionTitle: 'reviewTask-question--title',
  questionTitleHighlight: 'reviewTask-question--title-highlight',
  questionDescription: 'reviewTask-question--description',
  questionScore: 'reviewTask-question--score',
  questionComment: 'reviewTask-question--comment',
  questionCommentHighlight: 'reviewTask-question--comment-highlight',
  questionCommentContainer: 'reviewTask-question--comment-container',
};

export const COOKIE_AUTHTOKEN = 'newAuthtoken';

export const LOCALSTORAGE = {
  COOKIE_EXPIRES: 'cookie_expires',
};

export const ManageQuestionOperation = {
  RENAME: 'rename',
  DUPLICATE: 'duplicate',
  HIDE: 'hide',
  DELETE: 'delete',
};

export const RestApiMethod = {
  POST: 'post',
  GET: 'get',
  PUT: 'put',
  PATCH: 'patch',
};

export const NotQualifiedMessage = 'Not qualified to answer';
export const ClientId = '321595439871-riicahiicgpkk14eunj2dkb0ruemgp1i.apps.googleusercontent.com';

export const EReviewStatus = {
  ALL: 'All',
  INCOMPLETE: 'Incomplete',
  NOT_STARTED: 'Not Started',
  COMPLETE: 'Complete',
  ONGOING: 'ongoing',
  DONE: 'done',
};

export const EpersonalStatus = {
  COMPLETE: 1,
  INCOMPLETE: 2,
  NOT_STARTED: 3,
};

export const EConsolidationStatus = {
  ALL: 'All',
  NOT_YET: 'Not Yet',
  DONE: 'Done',
  DONE_AND_LOCKED: 'Done And Locked',
};

export const EQuestionCategory = {
  GENERAL: 'general',
  SKILL: 'skill',
};

export const EMenuId = {
  MANAGE_REVIEW: -1,
  MASTER_DATA: -2,
  DASHBOARD: 1,
  REVIEW_TASK: 2,
  REVIEW_RESULT: 3,
  CONSOLIDATION: 4,
  CONSOLIDATED_REVIEW: 5,
  MANAGE_QUESTION: 6,
  MANAGE_ASSIGNMENT: 7,
  REVIEW_ASSIGNMENT: 8,
  MANAGE_ROLE: 9,
  MANAGE_ROLE_LEVEL: 10,
  MANAGE_DEPARTMENTS: 11,
  MANAGE_PRACTICES: 12,
  MANAGE_PERIODS: 13,
  MANAGE_EMPLOYEE: 14,
  TEAM_ASSIGNMENT: 15,
  MANAGE_GENERAL_QUESTIONS: 16,
  USER_AUTHENTICATION: 19,
  MANAGE_DEPARTMENT_ROLE: 20,
  MANAGE_PROJECTS: 21,
  MANAGE_OFFICE: 22,
  MESSAGE_INBOX: 23,
  MESSAGE_INBOX_USER: 24,
  REVIEW_FEEDBACK: 25,
  LOGOUT: -3,
};

export const EPathname = {
  DASHBOARD: '/',
  REVIEW_TASK: '/ReviewTask',
  REVIEW_RESULT: '/ReviewResult',
  CONSOLIDATION: '/Consolidation',
  CONSOLIDATED_REVIEW: '/ConsolidatedReview',
  MANAGE_QUESTION: '/ManageQuestion',
  MANAGE_ASSIGNMENT: '/ManageAssignment',
  REVIEW_ASSIGNMENT: '/ReviewAssignment',
  MANAGE_ROLE: '/ManageRole',
  MANAGE_ROLE_LEVEL: '/ManageRoleLevel',
  MANAGE_DEPARTMENTS: '/ManageDepartment',
  MANAGE_PRACTICES: '/ManagePractice',
  MANAGE_PERIODS: '/ReviewPeriod',
  MANAGE_EMPLOYEE: '/ManageEmployee',
  TEAM_ASSIGNMENT: '/TeamAssignment',
  MANAGE_GENERAL_QUESTIONS: '/ManageGeneralQuestion',
  USER_AUTHENTICATION: '/UserAuthentication',
  MANAGE_DEPARTMENT_ROLE: '/ManageDepartmentRole',
  REVIEW_QUESTION: '/ReviewQuestion',
  CONSOLIDATION_REVIEW: '/ConsolidationReview',
  CONSOLIDATION_VIEW: '/ConsolidationView',
  CONSOLIDATION_TABLE: '/ConsolidationTable',
  REVIEW_FEEDBACK: '/ReviewFeedback',
  SCORING: '/Scoring',
  MANAGE_SKILL: '/ManageSkill',
  MANAGE_COMPANY: '/ManageCompany',
  MANAGE_PROJECT: '/ManageProject',
  MANAGE_OFFICE: '/ManageOffice',
  MESSAGE_INBOX_MANAGER: '/MessageInbox/All',
  MESSAGE_INBOX_USER: '/MessageInbox/Team',
};
export const ERoleId = {
  SUPER_ADMIN:0,
  ADMINISTRATOR: 1,
  MANAGER: 2,
  PM: 3,
  PMD: 4,
  PRACTICE_LEADER: 5,
  TEAM_LEADER: 6,
  TEAM_MEMBER: 7,
};
export const ETeamRole = {
  TEAM_MEMBER: 'Team Member',
  TEAM_LEADER: 'Team Leader',
  PRACTICE_LEADER: 'Practice Leader',
};
export const EResponseCode = {
  NO_ERROR: 0,
  ITEM_NOT_FOUND: -10,
  EMPLOYEE_DOES_NOT_EXIST: -25,
};

export const fillColorArray = {
  5: ['#f17a45', '#f19745', '#f1a545', '#f1b345', '#f1d045'],
  10: ['#f17a45', '#f17a45', '#f19745', '#f19745', '#f1a545', '#f1a545', '#f1b345', '#f1b345', '#f1d045', '#f1d045'],
  20: [
    '#f17a45',
    '#f17a45',
    '#f17a45',
    '#f17a45',
    '#f19745',
    '#f19745',
    '#f19745',
    '#f19745',
    '#f1a545',
    '#f1a545',
    '#f1a545',
    '#f1a545',
    '#f1b345',
    '#f1b345',
    '#f1b345',
    '#f1b345',
    '#f1d045',
    '#f1d045',
    '#f1d045',
    '#f1d045',
  ],
};

export const iconArray = {
  5: [
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            1
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            2
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            3
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            4
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            5
          </text>
        </svg>
      ),
    },
  ],
  10: [
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            1
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            2
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            3
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            4
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            5
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            6
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            7
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            8
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            9
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            10
          </text>
        </svg>
      ),
    },
  ],
  20: [
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            1
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            2
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            3
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            4
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            5
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            6
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            7
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            8
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            9
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            10
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            11
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            12
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            13
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            14
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            15
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            16
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            17
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            18
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            19
          </text>
        </svg>
      ),
    },
    {
      icon: (
        <svg height="50" width="50" fill="currentColor">
          <circle cx="25" cy="12" r="10" />
          <text x="50%" y="80%" dominantBaseline="middle" textAnchor="middle" fill="#212529">
            20
          </text>
        </svg>
      ),
    },
  ],
};

export const ScoreRanges = {
  SCORE_20: {
    type: QUESTION_TYPE.SCORE_20,
    label: '0-20',
    min: 0,
    max: 20,
  },
  SCORE_10: {
    type: QUESTION_TYPE.SCORE_10,
    label: '0-10',
    min: 0,
    max: 10,
  },
  SCORE_5: {
    type: QUESTION_TYPE.SCORE_5,
    label: '0-5',
    min: 0,
    max: 5,
  },
  SCORE_4: {
    type: QUESTION_TYPE.SCORE_4,
    label: '0-4',
    min: 0,
    max: 4,
  },
};

export const AuthColumnPageEnum = {
  AUTH_ROLE_COL: 'AuthRole',
  AUTH_ACTION_COL: 'AuthAction',
};

export const ConsolidationFilterType = {
  ROLE_TYPE: 'role',
  PRACTICE_TYPE: 'practice',
};

export const DefaultOffice = {
  DEFFAULT_VALUE: {id: 0, companyName: '', address: ''},
};

export const OfficeActionType = {
  CREATE: 'Create',
  UPDATE: 'Update',
  DELETE: 'Delete',
};

export const ESelectedTabs = {
  ALL_MESSAGE: 'All Messages',
  ARCHIVED: 'Archived',
  NEW_MESSAGE: 'New Message',
  SENT_MESSAGE: 'Sent',
  LEAD: ' to Lead',
  FORMULATRIX: 'to Formulatrix',
};

export const DashboardActionTypes = {
  SET_CHART_DATA: 'SET_CHART_DATA',
  SET_SELECTED_ITEMS: 'SET_SELECTED_ITEMS',
  SET_SELECTED_QUESTIONS: 'SET_SELECTED_QUESTIONS',
  SET_QUESTION_CATEGORY: 'SET_QUESTION_CATEGORY',
  SET_QUESTION_FILTERS: 'SET_QUESTION_FILTERS',
  SET_PERIOD_LIST: 'SET_PERIOD_LIST',
  SET_GROUPED_DATA: 'SET_GROUPED_DATA',
  SET_SELECTED_MENU: 'SET_SELECTED_MENU',
  SET_X_DATA: 'SET_X_DATA',
  SET_NEW_DATA_SERIES: 'SET_NEW_DATA_SERIES',
  SET_CATEGORY_SCORE: 'SET_CATEGORY_SCORE',
  SET_CHANGED_CATEGORY: 'SET_CHANGED_CATEGORY',
  SET_DASHBOARD_DATA: 'SET_DASHBOARD_DATA',
};

export const ChartColors = {
  Color1: '#4e79a7',
  Color2: '#f28e2c',
  Color3: '#e15759',
  Color4: '#76b7b2',
  Color5: '#59a14f',
  Color6: '#edc949',
  Color7: '#af7aa1',
  Color8: '#ff9da7',
  Color9: '#9c755f',
  Color10: '#bab0ab',
  Color11: '#6f4e7c',
  Color12: '#ff6f61',
  Color13: '#5d9ec9',
  Color14: '#f5a623',
  Color15: '#ce5a57',
  Color16: '#9b5de5',
  Color17: '#f15bb5',
  Color18: '#fee440',
  Color19: '#00bbf9',
  Color20: '#00f5d4',
  Color21: '#8c564b',
  Color22: '#c49c94',
  Color23: '#7f7f7f',
  Color24: '#bcbd22',
  Color25: '#17becf',
  Color26: '#1f77b4',
  Color27: '#ff7f0e',
  Color28: '#2ca02c',
  Color29: '#d62728',
  Color30: '#9467bd',
  Color31: '#8c564b',
  Color32: '#e377c2',
  Color33: '#7f7f7f',
  Color34: '#bcbd22',
  Color35: '#17becf',
  Color36: '#ffcc00',
  Color37: '#2b83ba',
  Color38: '#abdda4',
  Color39: '#fdae61',
  Color40: '#d7191c',
  Color41: '#2c7bb6',
  Color42: '#fdae61',
  Color43: '#abd9e9',
  Color44: '#f46d43',
  Color45: '#a6cee3',
  Color46: '#1f78b4',
  Color47: '#33a02c',
  Color48: '#fb9a99',
  Color49: '#e31a1c',
  Color50: '#ff7f00',
};

export const StatusConditionEnum = {
  NEW: 'New',
  DRAFT: 'Draft',
  PUBLISHED: 'Published',
  REJECTED: 'Rejected',
  NOT_YET: 'Not Yet',
  IN_PROGRESS: 'in progress',
  DONE: 'Done',
};

export const ManagerDataConfig = {
  id: 'id',
  reviewer: 'reviewer',
  reviewee: 'reviewee',
  practice: 'practice',
  level: 'level',
  projectID: 'projectID',
  project: 'project',
  relation: 'relation',
  status: 'status',
};

export const FeedbackFormulatrixConfig = {
  teamMember: 'teamMember',
  team: 'team',
  teamRole: 'teamRole',
  practice: 'practice',
  comments: 'comments',
};

export const MessageConfig = {
  id: 'id',
  senderId: 'senderId',
  receiverId: 'receiverId',
  projectId: 'projectId',
  sender: (item) => item.sender?.fullName || 'N/A',
  receiver: (item) => item.receiver?.fullName || 'N/A',
  type: 'messageType.name',
  date: (item) => new Date(item.dateCreated).toLocaleDateString('en-GB'),
  team: 'project.projectName',
  status: 'messageStatus.status',
  message: 'messageContent',
  isRead: 'isRead',
  anonimity: 'isAnonymous',
};

// export const feedbackLeadConfig = {
//   projectId: (project) => project.projectId,
//   projectLead: (project) => project.projectLead,
//   projectName: 'projectName',
//   members: (project) =>
//     project.feedbacks.map((feedback) => ({
//       id: feedback.employeeId,
//       name: feedback.teamMember,
//       practice: feedback.practice,
//       comments: feedback.comments,
//     })),
// };

export const ColumnAccessorEnum = {
  SENDER: 'sender',
  RECEIVER: 'receiver',
  DATE: 'date',
  TYPE: 'type',
  TEAM: 'team',
  PROJECT_NAME: 'projectName',
  STATUS: 'status',
  MEMBER: 'teamMember',
  PRACTICE: 'practice',
  LEVEL: 'level',
  PROJECT: 'project',
  RELATION: 'relation',
  COMMENT: 'comment',
};

export const LeadAccessorEnum = {
  PROJECT_ID: 'projectId',
  PROJECT_LEAD: 'projectLead',
  PROJECT_NAME: 'projectName',
  TEAM_MEMBER: 'name',
  PRACTICE: 'practice',
  COMMENTS: 'comments',
};

export const ManagerAccessorEnum = {
  REVIEWEE: {
    id: 1,
    Header: 'Reviewee',
    accessor: 'reviewee',
    sortable: true,
  },
  PRACTICE: {
    id: 2,
    Header: 'Practice',
    accessor: 'practice',
    sortable: true,
  },
  LEVEL: {
    id: 3,
    Header: 'Level',
    accessor: 'level',
    sortable: true,
  },
  PROJECT_ID: {
    id: 4,
    Header: 'Project ID',
    accessor: 'projectID',
    sortable: true,
  },
  PROJECT: {
    id: 5,
    Header: 'Project',
    accessor: 'project',
    sortable: true,
  },
  RELATION: {
    id: 6,
    Header: 'Relation',
    accessor: 'relation',
    sortable: true,
  },
  STATUS: {
    id: 7,
    Header: 'Status',
    accessor: 'status',
    sortable: true,
  },
};
export const ManagerTableAccessorEnum = {
  REVIEWER: {
    id: 1,
    Header: 'Reviewer',
    accessor: 'reviewer',
    sortable: true,
  },
  PRACTICE: {
    id: 2,
    Header: 'Practice',
    accessor: 'practice',
    sortable: true,
  },
  LEVEL: {
    id: 3,
    Header: 'Level',
    accessor: 'level',
    sortable: true,
  },
  PROJECT_ID: {
    id: 4,
    Header: 'Project ID',
    accessor: 'projectID',
    sortable: true,
  },
  PROJECT: {
    id: 5,
    Header: 'Project',
    accessor: 'project',
    sortable: true,
  },
  RELATION: {
    id: 6,
    Header: 'Relation',
    accessor: 'relation',
    sortable: true,
  },
  STATUS: {
    id: 7,
    Header: 'Status',
    accessor: 'status',
    sortable: true,
  },
};

export const LeadFeedbackEnum = {
  PROJECT_NAME: {
    id: 1,
    Header: 'Team',
    accessor: 'projectName',
    sortable: true,
  },
  TEAM_MEMBER: {
    id: 2,
    Header: 'Team Member',
    accessor: 'projectLead',
    sortable: false,
  },
  PRACTICE: {
    id: 3,
    Header: 'Practice',
    sortable: false,
  },
  COMMENTS: {
    id: 4,
    Header: 'Comments',
    sortable: false,
  },
  ACTION: {
    id: 5,
    Header: '',
    sortable: false,
  },
};

export const FormulatrixFeedbackEnum = {
  TEAM_MEMBER: {
    id: 1,
    Header: 'Name',
    className: 'Name-column',
    accessor: 'teamMember',
    sortable: true,
  },
  TEAM: {
    id: 2,
    Header: 'Team',
    accessor: 'team',
    sortable: true,
  },
  ROLE: {
    id: 3,
    Header: 'Role',
    accessor: 'teamRole',
    sortable: true,
  },
  PRACTICE: {
    id: 4,
    Header: 'Practice',
    accessor: 'practice',
    className: 'practice-column',
    sortable: true,
  },
  COMMENTS: {
    id: 5,
    Header: 'Comments',
    className: 'comments-column',
    accessor: 'comments',
    sortable: true,
  },
};

export const PaginationEnum = {
  PAGE_SIZE: 10,
  PAGE_OPTIONS: [10, 20, 30],
};

export const TeamColumnsEnum = {
  SENDER: {
    id: 1,
    Header: 'Sender',
    accessor: 'sender',
    className: 'sender-column',
    sortable: true,
    filter: 'TEXT',
  },
  RECEIVER: {
    id: 2,
    Header: 'Receiver',
    accessor: 'receiver',
    className: 'receiver-column',
    sortable: true,
    filter: 'TEXT',
  },
  TYPE: {
    id: 4,
    Header: 'Type',
    accessor: 'type',
    sortable: true,
  },
  DATE: {
    id: 3,
    Header: 'Date',
    accessor: 'date',
    sortable: true,
  },
  COMMENT: {
    id: 4,
    Header: 'Message',
    classNames: 'messages',
    accessor: 'message',
  },
};

export const AdminColumnsEnum = {
  SENDER: {
    id: 1,
    Header: 'Sender',
    accessor: 'sender',
    className: 'sender-column',
    sortable: true,
    filter: 'TEXT',
  },
  RECEIVER: {
    id: 2,
    Header: 'Receiver',
    accessor: 'receiver',
    className: 'receiver-column',
    sortable: true,
    filter: 'TEXT',
  },
  DATE: {
    id: 3,
    Header: 'Date',
    accessor: 'date',
    sortable: true,
  },
  TYPE: {
    id: 4,
    Header: 'Type',
    accessor: 'type',
    sortable: true,
  },
  STATUS: {
    id: 6,
    Header: 'Status',
    accessor: 'status',
    sortable: true,
  },
};

export const TableColumnsEnum = {
  SENDER: {id: 1, Header: 'Sender', accessor: 'sender', className: 'sender-column', sortable: true},
  RECEIVER: {id: 2, Header: 'Receiver', accessor: 'receiver', className: 'receiver-column', sortable: true},
  DATE: {id: 3, Header: 'Date', accessor: 'date', sortable: true},
  TEAM: {id: 4, Header: 'Team', accessor: 'team', sortable: true},
  STATUS: {id: 5, Header: 'Status', accessor: 'status', sortable: true},
};

export const MessageTypes = {
  CRITICISM: {id: 2, text: 'Criticism', group: 'Category'},
  KUDOS: {id: 1, text: 'Kudos', group: 'Category'},
};

export const ResponseCodeStatus = {
  SUCCESS: 0,
  FAIL: -23,
  INTERCEPT: -1,
};

export const AuthRole = {
  TEAM_MEMBER: 'Team Member',
  ADMINISTRATOR: 'Administrator',
  MANAGER: 'Manager',
};

export const Reducers = {
  TEAM_ASSIGNMENT : "teamAssignmentStateReducer",
  PRACTICE: 'practiceState',
  DEPARTMENT: 'departmentState',
  PERIOD: 'periodState',
};
